import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "field col-12 lg:col-7" }, null, -1)
const _hoisted_4 = { class: "field col-12 lg:col-2 text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_6 = {
  key: 0,
  class: "col-12"
}
const _hoisted_7 = {
  key: 1,
  class: "field col-12 text-right"
}
const _hoisted_8 = {
  key: 2,
  class: "col-12"
}
const _hoisted_9 = { class: "text-bold" }
const _hoisted_10 = {
  key: 0,
  class: "badge status-green"
}
const _hoisted_11 = {
  key: 1,
  class: "badge status-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statBranchWithEmployee.date")), 1),
        _createVNode(_component_Calendar, {
          showIcon: true,
          showOnFocus: false,
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
          onDateSelect: _ctx.dataChanged
        }, null, 8, ["modelValue", "onDateSelect"])
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.print'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printPaper()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_DataTable, {
              dataKey: "branch.id",
              expandedRows: _ctx.expandedRows,
              "onUpdate:expandedRows": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.expandedRows) = $event)),
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: "branch.name",
              sortOrder: 1,
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              expansion: _withCtx(({ data }) => [
                _createVNode(_component_DataTable, {
                  dataKey: "employee.id",
                  responsiveLayout: "scroll",
                  showGridlines: "",
                  sortField: "employee.fullName",
                  sortOrder: 1,
                  stripedRows: "",
                  value: data.employeesWithPosition
                }, {
                  empty: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
                  ]),
                  loading: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "employee",
                      header: _ctx.t('employee.employee'),
                      headerStyle: "width: 45%"
                    }, {
                      body: _withCtx(({ data, field }) => [
                        _createTextVNode(_toDisplayString(data[field]?.fullName ?? "-"), 1)
                      ]),
                      _: 2
                    }, 1032, ["header"]),
                    _createVNode(_component_Column, {
                      field: "position",
                      header: _ctx.t('employeePosition.employeePosition'),
                      headerStyle: "width: 25%"
                    }, {
                      body: _withCtx(({ data, field }) => [
                        _createTextVNode(_toDisplayString(data[field]?.name ?? "-"), 1)
                      ]),
                      _: 2
                    }, 1032, ["header"]),
                    _createVNode(_component_Column, {
                      field: "leave",
                      header: _ctx.t('employeeLeave.employeeLeave'),
                      bodyClass: "text-center",
                      headerStyle: "width: 30%"
                    }, {
                      body: _withCtx(({ data, field }) => [
                        (data[field] === undefined)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t("gen.no")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(data[field]?.name ?? "-"), 1))
                      ]),
                      _: 2
                    }, 1032, ["header"])
                  ]),
                  _: 2
                }, 1032, ["value"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  expander: "",
                  bodyClass: "text-center",
                  style: {"width":"5%"}
                }),
                _createVNode(_component_Column, {
                  field: "branch",
                  header: _ctx.t('branch.branch'),
                  headerStyle: "width: 95%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(data[field]?.name ?? "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["expandedRows", "value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}